import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import * as moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { ACCOUNT_TYPES } from 'src/app/shared/commons/accountTypes';
import { INCOME_TYPE_ITEMS } from 'src/app/shared/commons/incomeTypes';
import { getAccountLabel, Utils, valueOrDefault } from 'src/app/shared/commons/Utils';
import { Validations } from 'src/app/shared/commons/Validations';
import { ExtractOptionsEnum } from 'src/app/shared/enums/extract-type';
import { NumerairesEnum } from 'src/app/shared/enums/numeraires.enum';
import { PaymentTypeEnum } from 'src/app/shared/enums/payment-type.enum';
import { RecurrenceEnum, RecurrenceValueEnum } from 'src/app/shared/enums/recurrence.enum';
import { ClientModel } from 'src/app/shared/interfaces/client-model';
import { ClientService } from 'src/app/shared/services/client.service';
import { CommonService } from 'src/app/shared/services/common.service';

@Component({
  selector: 'app-income-or-expense-registration-dialog',
  templateUrl: './income-or-expense-registration-dialog.component.html',
  styleUrls: ['./income-or-expense-registration-dialog.component.scss']
})
export class IncomeOrExpenseRegistrationDialogComponent implements OnInit {

  client = {} as ClientModel
  formGroup: FormGroup
  registerTypes: any = [
    { value: 'expense', name: 'Despesa', disabled: false },
    { value: 'income', name: 'Receita', disabled: false },
    { value: 'transfer', name: 'Transferência', disabled: true }
  ]
  numerairesTypes: any = []
  currencyOption = { prefix: 'R$ ', thousands: '.', decimal: ',', suffix: '', precision: 2 }
  bsConfig = Object.assign({}, {
    containerClass: 'theme-default',
    adaptivePosition: true,
    isAnimated: true,
    dateInputFormat: 'DD/MM/YYYY'
  })
  isIncome = true
  isAccount: boolean = null
  type: string
  confirmResult: Subject<boolean>
  incomeTypes: any = INCOME_TYPE_ITEMS()
  listPaymentTypes: any = Object.keys(PaymentTypeEnum).map(key => {
    return ({ value: key, name: PaymentTypeEnum[key] })
  })
  listRecurrence: any = Object.keys(RecurrenceValueEnum).map(key => {
    return ({ value: RecurrenceValueEnum[key], name: RecurrenceEnum[key] })
  })
  accounts: any = []
  categories: any = []
  subCategories: any = []
  connections: any = []
  numeraireValue?: string = null
  model: any = {}
  connection: any = {}

  constructor(
    private clientService: ClientService,
    private commonService: CommonService,
    public modalRef: BsModalRef,
    private fb: FormBuilder,
  ) { }

  ngOnInit() {
    this.confirmResult = new Subject()
    this.clientService.clientData.subscribe(d => {
      if (!d) { return; }
      this.client = d;
    })
    if (this.model?.transaction_type)
      this.isAccount = this.model.transaction_type !== ExtractOptionsEnum.credit_card
    
    this.loadForm()
    this.getConnections()
    this.getInvestorAccounts()
    this.getCategories()
    this.getSubCategories()
    this.numerairesTypes = [
      { value: 'BUDGET_CASH_IN_BRL', name: 'Orçada', disabled: false },
      { value: 'BRL', name: 'Efetiva', disabled: false },
    ]
    this.incomeTypes = [
      { value: 'BUDGET_CASH_IN_BRL', name: 'Orçada', disabled: false },
      { value: 'BRL', name: 'Efetiva', disabled: false },
    ]
  }

  loadForm() {
    if (this.model?.transaction_type)
      this.isAccount = this.model.transaction_type !== ExtractOptionsEnum.credit_card

    if (this.numeraireValue) {
      switch (this.numeraireValue) {
        case 'BRL':
          if (this.isAccount) {
            this.createForm(this.model)
            this.formGroup.addControl('account_uuid', this.fb.control(this.model?.account_info?.uuid))
          } else if (this.isAccount === false) {
            this.createForm(this.model)
            this.formGroup.addControl('identification_number', this.fb.control(this.model?.card_info?.identification_number))
            this.formGroup.addControl('currency', this.fb.control(this.model?.card_info?.currency?.alpha_3))
            this.formGroup.addControl('card_uuid', this.fb.control(this.model?.card_info?.uuid, Validators.required))
            this.formGroup.addControl('installment', this.fb.control(this.model?.installment))
          }
          break;
        case 'BUDGET_CASH_IN_BRL':
          this.createForm(this.model?.budgeted[0])
          this.formGroup.addControl('frequency', this.fb.control(valueOrDefault(this.model?.budgeted[0]?.frequency, 0), Validators.required))
          this.formGroup.addControl('repetitions', this.fb.control(valueOrDefault(this.model?.budgeted[0]?.repetitions, 0)))
          break;
      }
    } else if (this.formGroup?.controls) {
      this.formGroup.reset()
    }
  }

  createForm(model: any) {
    const date = model?.date ? model?.date : model?.expected_settlement_date ? moment(model?.expected_settlement_date, 'YYYY-MM-DD').toDate() : new Date()
    this.formGroup = this.fb.group({
      transaction_date: [date, [Validators.required, Validations.Date]],
      name: [model?.name, Validators.required],
      category: [model?.category],
      subcategory: [valueOrDefault(model?.sub_category, model?.subcategory)],
      type: [this.isIncome ? 'credit' : 'debit'],
      amount: [valueOrDefault(model?.effective, model?.value), Validators.required],
    })
  }

  async getConnections() {
    this.connections = []
    const $res: any = await this.clientService.getConnections()
    this.connections = $res.connections
  }

  async getInvestorAccounts() {
    const filter = { account_type: ACCOUNT_TYPES().map(x => x.value).join() }
    const $res = await this.clientService.getInvestorAccounts(filter)
    this.accounts = _.orderBy($res, ['name'], ['asc'])
  }

  async getCategories() {
    this.categories = await this.commonService.getCategories()
  }

  async getSubCategories() {
    this.subCategories = await this.commonService.getSubCategories()
  }

  onSelectAccount(account_uuid: string) {
    this.connection = {}

    for (const conn of this.connections) {
      const acc = conn.accounts.find(a => a.uuid === account_uuid);
      if (acc) {
        this.connection = conn
        this.f.account_uuid.setValue(account_uuid)
        break;
      }
    }
  }


  onSelectCard(card_uuid) {
    this.connection = {}
    if (card_uuid) {
      const card = this.connections?.flatMap(connection => connection.cards ?? [])?.find(card => card.uuid === card_uuid)
      this.f.currency.setValue(card?.currency?.alpha_3, 'BRL')
      this.f.identification_number.setValue(card?.identification_number)
      this.connection = this.connections?.find(connection => connection.cards?.some(card => card.uuid === card_uuid))
    }
  }

  getAccountLabel(account) {
    return getAccountLabel(account.account_type)
  }

  async submit() {
    if (this.formGroup.valid) {
      let transaction = this.formGroup.value
      let body: any = {}

      if (this.numeraireValue === NumerairesEnum.BRL) {
        if (this.isAccount && transaction?.account_uuid) {
          body = {
            amount: transaction?.type == 'credit' ? transaction.amount : transaction.amount * -1,
            category: transaction.category,
            currency: valueOrDefault(transaction.currency, 'BRL'),
            name: transaction.name,
            sub_category: transaction.subcategory,
            transaction_date: moment(transaction.transaction_date).unix(),
          }
          if (this.model?.uuid)
            await this.clientService.updateAccountTransaction(this.connection.uuid, transaction.account_uuid, this.model.uuid, body)
          else
            await this.clientService.saveAccountTransaction(this.connection.uuid, transaction.account_uuid, body)
        } else {
          body = {
            amount: transaction?.type == 'credit' ? transaction.amount : transaction.amount * -1,
            category: transaction.category,
            credit_debit_type: transaction?.type,
            currency: valueOrDefault(transaction.currency, 'BRL'),
            identification_number: transaction.identification_number,
            installment: parseInt(valueOrDefault(transaction?.installment, 1)),
            name: transaction.name,
            sub_category: transaction.subcategory,
            transaction_date: moment(transaction.transaction_date).format('YYYY-MM-DD HH:mm:ss')
          }
          if (this.model?.uuid)
            await this.clientService.updateCardTransaction(this.connection.uuid, transaction.card_uuid, this.model.uuid, body)
          else
            await this.clientService.saveCardTransaction(this.connection.uuid, transaction.card_uuid, body)
        }
      } else {
        body = {
          expected_settlement_date: moment(transaction?.transaction_date).format('YYYY-MM-DD'),
          category: transaction?.category,
          currency: valueOrDefault(transaction.currency, 'BRL'),
          subcategory: transaction?.subcategory,
          value: transaction?.type === 'credit' ? transaction?.amount : transaction?.amount * -1,
          frequency: +transaction?.frequency,
          repetitions: transaction?.repetitions
        }

        if (this.model?.uuid)
          await this.clientService.updateBudget(this.model.uuuid, body)
        else
          await this.clientService.saveBudget(body)
      }
      // TO DO: transfer ainda não tem EP
      this.confirmResult.next(true)
      this.modalRef.hide()
    } else {
      this.formGroup.markAllAsTouched()
    }
  }

  get extractOptions() {
    return ExtractOptionsEnum
  }

  get isNull() {
    return Utils.isNull
  }

  get f() {
    return this.formGroup.controls
  }
}
